import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { getChangedItems } from "../../../components/util/helpers";
import {
  setChangedFormItems,
  commitChanges,
  loadRecord,
} from "../patientSlice";
import moment from "moment";
import { IonButton, IonLoading } from "@ionic/react";
import { Emergency } from "../../../components/Emergency";

var flatten = require("flat");

const FormWrapper = (props) => {
  const { type } = props;
  const activePatient = useSelector((state) => state.patient.activePatient);

  const intl = useIntl();
  const dispatch = useDispatch();
  const saveLoading = useSelector(
    (state) => state.pendingActions["patient/update"]
  );

  const changedItems = useSelector((state) => state.patient.changedItems);
  const changedValues = useSelector((state) => state.patient.changedValues);
  const { handleSubmit, control, watch, reset } = useForm({});

  useEffect(() => {
    reset(activePatient);
  }, [activePatient, reset]);

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      const flatData = flatten(value, { safe: true });
      const arr = getChangedItems(
        { [name]: flatData[name] },
        flatData,
        changedItems,
        activePatient
      );
      if (
        changedItems.includes("emergency.guidance_date") ||
        name === "emergency.guidance_date"
      ) {
        flatData["emergency.guidance_date"] = moment(
          flatData["emergency.guidance_date"]
        ).format();
      }
      dispatch(setChangedFormItems({ changed: arr, values: { ...flatData } }));
    });
    return () => subscription.unsubscribe();
  }, [watch, changedItems, changedValues, activePatient, dispatch]);

  const onFinish = async () => {
    const params = {
      patient: { id: activePatient.id },
      branchId: activePatient.branch,
    };
    const action = await dispatch(commitChanges(params));
    if (!action.error) {
      const patientParams = {
        id: activePatient.id,
        branchId: activePatient.branch,
        admin: false,
        patientId: activePatient.id,
      };
      dispatch(loadRecord(patientParams));
    }
  };

  return (
    <form>
      <div>
        {type === "emergency" && (
          <Emergency
            changedItems={changedItems}
            changedValues={changedValues}
            control={control}
            isFromVisitScreen={false}
            loading={saveLoading}
          />
        )}
        <div style={{ padding: "0 16px 16px 16px" }}>
          <IonButton
            expand="block"
            type="submit"
            disabled={!changedItems || changedItems.length === 0}
            onClick={() => onFinish()}
          >
            {intl.formatMessage({
              id: "app.mobile.actions.save",
            })}
          </IonButton>

          {saveLoading && (
            <IonLoading
              isOpen={true}
              message={intl.formatMessage({
                id: "app.mobile.alert.saving_data",
              })}
            />
          )}
        </div>
      </div>
    </form>
  );
};

export default FormWrapper;
